enum TipoNotaFiscal {
    Servico = 0,
    CupomFiscal = 1,
    DANFe = 2,
    CFe = 3,
}

export default TipoNotaFiscal;
